//central of variables and methods
import { createStore } from "vuex";
import axios from "axios";
import Constants from "./constants.ts";
const store = createStore({
  state: {
    tempAttData: [],
    leadData: [],
    planclass_list: [],
    coverages: [],
    cases_list: [],
    request_list: [],
    stateList: [],
    countyList: [],
    address_county: null,
    attorney_data: [],
    att_user: [],
    errors: [],
    attorney_files: [],
    profile_data: [],
    dashboard_data: [],
    matter_cases: [],
    is_uploaded: false,
    is_forgot: false,
    is_sent_reset_link: false,
    is_password_link_expired: false,
    is_password_changed: false,
    password_reset_data: [],
    is_attorney_updated: false,
    is_duplicate_username: null,
    case_list: [], //Added By Vishal
    cdl_case_list: [],
    matter_case_list: []
  },
  mutations: {
    SAVE_LEAD(state, leadData) {
      state.leadData = leadData;
    },
    SAVE_TEMP_ATT_DATA(state, tempAttData) {
      state.tempAttData = tempAttData;
    },
    SAVE_FILES(state, attorney_files) {
      state.attorney_files = attorney_files;
    },
    SAVE_PLAN_CLASS(state, data) {
      state.planclass_list = data;
    },
    SAVE_ATT_USER(state, data) {
      state.att_user = data;
    },
    SAVE_DASHBOARD_DATA(state, data) {
      state.dashboard_data = data;
    },
    SAVE_COVERAGES(state, data) {
      state.coverages = data;
    },
    SAVE_STATE(state, data) {
      state.stateList = data;
    },
    SAVE_COUNTY(state, data) {
      state.countyList = data;
    },
    SAVE_ADDRESS_COUNTY(state, data) {
      state.address_county = data;
    },
    SAVE_CASE_LIST(state, data) {
      state.case_list = data;
    },
    SAVE_MATTER_CASE_LIST(state, data) {
      console.log("matter_case_list", data);
      state.matter_case_list = data;
    },
    SAVE_CDL_CASE_LIST(state, data) {
      state.cdl_case_list = data;
    },
    ATTORNEY_DATA(state, data) {
      state.attorney_data = data;
    },
    CASES_DATA(state, data) {
      state.cases_list = data;
    },
    AUTHORIZATION_DATA(state, data) {
      state.request_list = data;
    },
    SAVE_SIGNATURE_ID(state, data) {
      state.signature_id = data;
    },
    SET_ERRORS(state, errors) {
      state.errors = errors;
    },
    SET_PROFILE_DATA(state, data) {
      state.profile_data = data;
    },
    UPLOAD_FLAG(state, flag) {
      state.is_uploaded = flag;
    },
    FORGOT_USERNAME(state, flag) {
      state.is_forgot = flag;
    },
    PASSWORD_CHANGE_STATUS(state, flag) {
      state.is_password_changed = flag;
    },
    SET_PASSWORD_LINK_STATUS(state, flag) {
      state.is_password_link_expired = flag;
    },
    IS_SENT_RESET_LINK(state, flag) {
      state.is_sent_reset_link = flag;
    },
    SET_PASSWORD_RESET(state, data) {
      state.password_reset_data = data;
    },
    CHECK_VALID_USERNAME(state, flag) {
      state.is_duplicate_username = flag;
    },
    UPDATE_ATTORNEY_FLAG(state, flag) {
      state.is_attorney_updated = flag;
    },
    MATTER_CASE_DATA(state, data) {
      state.matter_cases = data;
    }
  },
  actions: {
    loadLeadData({ commit }, leadId) {
      var config = {
        method: "post",
        url: Constants.API_BASE + "getLead.php",
        headers: {
          "Content-Type": "text/plain"
        },
        data: { emailAddress: leadId }
      };
      axios(config)
        .then(result => {
          if (result.data != undefined && result.data.result.lead.length > 0) {
            var config1 = {
              method: "post",
              url: Constants.API_BASE + "attorney_check.php",
              headers: {
                "Content-Type": "text/plain"
              },
              data: { emailAddress: leadId,lead_id:result.data.result.lead[0].id }
            };
            axios(config1)
              .then(result1 => {
                result.data.result.no_rec = result1.data.n_rec;
                commit("SAVE_LEAD", result.data);
                commit("SAVE_TEMP_ATT_DATA", result1.data);
                localStorage.setItem('tempAttData',JSON.stringify(result1.data));
                commit("SET_ERRORS", []);
              })
              .catch(error => {
                throw new Error(`API ${error}`);
              });
          } else {
            commit("SET_ERRORS", [{ message: "Email not Found" }]);
          }
        })
        .catch(error => {
          commit("SET_ERRORS", error);
        });
    },
    setLeadData({ commit }) {
      let leadData = JSON.parse(localStorage.getItem("leadData"));
      commit("SAVE_LEAD", leadData);
    },
    settempAttData({ commit }) {
      let tempAttData = JSON.parse(localStorage.getItem("tempAttData"));
      commit("SAVE_TEMP_ATT_DATA", tempAttData);
    },
    setAttData({ commit }) {
      let attData = JSON.parse(localStorage.getItem("att_data"));
      commit("SAVE_ATT_USER", attData);
    },
    setAttorneyData({ commit }) {
      let attData = JSON.parse(localStorage.getItem("attorney_data"));
      commit("ATTORNEY_DATA", attData);
    },
    getAttProfileData({ commit }) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "getAttorneyInfo.php",
        headers: {
          "Content-Type": "text/plain",
          Authorization: this.state.att_user.data.token
        },
        data: JSON.stringify({"username":this.state.att_user.data.username})
      };
      axios(config)
        .then(result => {
          console.log(result, "result");
          document.getElementById("loader").classList.add("hidden");
          if (result.data.status == "Failed") {
            commit("SET_ERRORS", { message: result.data.message });
          } else {
            commit("SET_PROFILE_DATA", result.data.attorney);
          }
        })
        .catch(error => {
          commit("SET_ERRORS", error);
        });
    },
    getDashboardData({ commit }) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "dashboard_details.php",
        headers: {
          "Content-Type": "text/plain",
          Authorization: this.state.att_user.data.token
        },
        data: JSON.stringify({"username":this.state.att_user.data.username})
      };
      axios(config)
        .then(result => {
          if (result.data.status == "Failed") {
            commit("SET_ERRORS", { message: result.data.message });
          } else {
            document.getElementById("loader").classList.add("hidden");
            commit("SAVE_DASHBOARD_DATA", result.data.data);
          }
        })
        .catch(error => {
          commit("SET_ERRORS", error);
        });
    },
    storAttorneyData({ commit }, data) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "create_attorney.php",
        headers: {
          "Content-Type": "text/plain"
        },
        data: JSON.stringify(data)
      };
      axios(config)
        .then(result => {
          document.getElementById("loader").classList.add("hidden");
          if (result.data.status != "error") {
            data.data.id=result.data.attorney.id;
            commit("ATTORNEY_DATA", data.data);
            let leadData = JSON.parse(localStorage.getItem("leadData"));
            localStorage.setItem("attorney_data",JSON.stringify(data.data));
            leadData.result.lead[0].attorney_id = result.data.attorney_id;
            localStorage.setItem("leadData", JSON.stringify(leadData));
            commit("SAVE_LEAD", leadData);
            commit("SET_ERRORS", []);
          } else {
            commit("SET_ERRORS", { message: "Something went wrong" });
          }
        })
        .catch(error => {
          commit("SET_ERRORS", error);
        });
    },
    createSignRequest(context, payload) {
      document.getElementById("loader").classList.remove("hidden");
      payload.file_type="enrollment";
      var config1 = {
        method: "post",
        url: Constants.API_BASE + "tcpdf/pdf/attorney_app_pdf.php",
        headers: {
          "Content-Type": "text/plain"
        },
        data: JSON.stringify(payload)
      };
      return new Promise((resolve, reject) => {
      axios(config1)
        .then(result1 => {
            document.getElementById("loader").classList.add("hidden");
            if (result1.data.status!= "error") {
              var config2 = {
                method: "post",
                url: Constants.API_BASE + "createSignRequests.php",
                headers: {
                  "Content-Type": "text/plain"
                },
                data: JSON.stringify(payload)
              };
              axios(config2)
                .then(result2 => {
                  console.log(result2.data);
                  setTimeout(() => {
                    var URLconfig = {
                      method: "post",
                      url: Constants.API_BASE + "getEmbeddedSignUrl.php",
                      headers: {
                        "Content-Type": "text/plain"
                      },
                      data: {
                        signId:
                          result2.data.signature_request.signatures[0]
                            .signature_id,
                        signature_request_id:
                          result2.data.signature_request.signature_request_id,
                        attorney_id: payload.id
                      }
                    };
                    axios(URLconfig)
                      .then(url_result => {
                        resolve(url_result.data);
                      })
                      .catch(error => {
                        reject(error);
                      });
                  }, 2000);
                })
                .catch(error => {
                  reject(error);
                });
            }else{
              reject("Something went Wrong");
            }
        })
        .catch(error => {
          document.getElementById("loader").classList.add("hidden");
          reject(error);
        });
      });
    },
    createEmailSignRequest(context, payload) {
      document.getElementById("loader").classList.remove("hidden");
      payload.file_type="enrollment";
      var config1 = {
        method: "post",
        url: Constants.API_BASE + "tcpdf/pdf/attorney_app_pdf.php",
        headers: {
          "Content-Type": "text/plain"
        },
        data: JSON.stringify(payload)
      };
      return new Promise((resolve, reject) => {
      axios(config1)
        .then(result1 => {
            document.getElementById("loader").classList.add("hidden");
            if (result1.data.status!= "error") {
              var config2 = {
                method: "post",
                url: Constants.API_BASE + "generateEmailSignRequest.php",
                headers: {
                  "Content-Type": "text/plain"
                },
                data: JSON.stringify(payload)
              };
              axios(config2)
                .then(result2 => {
                  resolve(result2);
                })
                .catch(error => {
                  reject(error);
                });
            }else{
              reject("Something went Wrong");
            }
        })
        .catch(error => {
          document.getElementById("loader").classList.add("hidden");
          reject(error);
        });
      });
    },
    saveAttorneyTempData(context, payload) {
      payload.language="";
      payload.lang_spoken="";
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "save_attorney_temp_data.php",
        headers: {
          "Content-Type": "text/plain"
        },
        data: {lead_id:payload.lead_id,data:JSON.stringify(payload)}
      };
      return new Promise((resolve, reject) => {
        axios(config)
          .then(result => {
            document.getElementById("loader").classList.add("hidden");
            if (result.data.status == "error") {
              reject(result.data);
            } else {
              resolve(result);
            }
          })
          .catch(error => {
            document.getElementById("loader").classList.add("hidden");
            reject(error.response.data.errors);
          });
      });
    },
    downloadAppPdf(context, data) {
      data.file_type="attorney_app";
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "tcpdf/pdf/attorney_app_pdf.php",
        headers: {
          "Content-Type": "text/plain"
        },
        data: JSON.stringify(data)
      };
      return new Promise((resolve, reject) => {
        axios(config)
          .then(result => {
            document.getElementById("loader").classList.add("hidden");
            if (result.data.status == "error") {
              reject(result.data);
            } else {
              resolve(result.data);
            }
          })
          .catch(error => {
            document.getElementById("loader").classList.add("hidden");
            reject(error.response.data.errors);
          });
      });
    },
    updateAttorneyData({ commit }, data) {
      data.username=this.state.att_user.data.username;
      data.lead_id=this.state.att_user.data.lead_id;
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "update_attorney_profile.php",
        headers: {
          "Content-Type": "text/plain",
          Authorization: this.state.att_user.data.token
        },
        data: JSON.stringify(data)
      };
      axios(config)
        .then(result => {
          document.getElementById("loader").classList.add("hidden");
          if (result.data.status == "Failed") {
            commit("SET_ERRORS", { message: result.data.message });
          } else {
            if (result.data?.status == "error") {
              commit("SET_ERRORS", [{ message: "Something went wrong!" }]);
            } else {
              commit("UPDATE_ATTORNEY_FLAG", true);
              commit("SET_ERRORS", []);
            }
          }
        })
        .catch(error => {
          commit("SET_ERRORS", error);
        });
    },
    checkValidUsername({ commit }, data) {
      var config = {
        method: "post",
        url: Constants.API_BASE + "check_valid_username.php",
        headers: {
          "Content-Type": "text/plain"
        },
        data: JSON.stringify(data)
      };
      axios(config)
        .then(result => {
          commit("CHECK_VALID_USERNAME", result.data);
        })
        .catch(error => {
          commit("SET_ERRORS", error);
        });
    },
    checkPasswordLinkStatus({ commit }, data) {
      var config = {
        method: "post",
        url: Constants.API_BASE + "check_password_link_status.php",
        headers: {
          "Content-Type": "text/plain"
        },
        data: JSON.stringify(data)
      };
      axios(config)
        .then(result => {
          console.log(result);
          if (result.data?.status == "error") {
            commit("SET_ERRORS", [{ message: result.data["message"] }]);
          } else {
            commit("SET_PASSWORD_LINK_STATUS", result.data.data);
          }
        })
        .catch(error => {
          commit("SET_ERRORS", error);
        });
    },
    resetPassword({ commit }, data) {
      var config = {
        method: "post",
        url: Constants.API_BASE + "reset_password.php",
        headers: {
          "Content-Type": "text/plain"
        },
        data: JSON.stringify(data)
      };
      axios(config)
        .then(result => {
          console.log(result);
          if (result.data?.status == "error") {
            commit("SET_ERRORS", [{ message: result.data["message"] }]);
          } else {
            commit("PASSWORD_CHANGE_STATUS", result.data.data);
          }
        })
        .catch(error => {
          commit("SET_ERRORS", error);
        });
    },
    forgotUsername({ commit }, data) {
      var config = {
        method: "post",
        url: Constants.API_BASE + "forgot_username.php",
        headers: {
          "Content-Type": "text/plain"
        },
        data: JSON.stringify(data)
      };
      axios(config)
        .then(result => {
          console.log(result);
          if (result.data?.status == "error") {
            commit("SET_ERRORS", [{ message: result.data["message"] }]);
          } else {
            commit("FORGOT_USERNAME", result.data.data);
          }
        })
        .catch(error => {
          commit("SET_ERRORS", error);
        });
    },
    getResetPasswordLink({ commit }, data) {
      var config = {
        method: "post",
        url: Constants.API_BASE + "get_reset_password_link.php",
        headers: {
          "Content-Type": "text/plain"
        },
        data: JSON.stringify(data)
      };
      axios(config)
        .then(result => {
          console.log(result);
          if (result.data?.status == "error") {
            commit("SET_ERRORS", [{ message: result.data["message"] }]);
          } else {
            commit("IS_SENT_RESET_LINK", result.data.data);
          }
        })
        .catch(error => {
          commit("SET_ERRORS", error);
        });
    },
    getSecretQuestion({ commit }, data) {
      var config = {
        method: "post",
        url: Constants.API_BASE + "get_secret_question.php",
        headers: {
          "Content-Type": "text/plain"
        },
        data: JSON.stringify(data)
      };
      axios(config)
        .then(result => {
          console.log(result);
          if (result.data?.status == "error") {
            commit("SET_ERRORS", [{ message: result.data["message"] }]);
          } else {
            commit("SET_PASSWORD_RESET", result.data.data);
          }
        })
        .catch(error => {
          commit("SET_ERRORS", error);
        });
    },
    loginAttorney({ commit }, data) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "login_attorney.php",
        headers: {
          "Content-Type": "text/plain"
        },
        data: JSON.stringify(data)
      };
      axios(config)
        .then(result => {
          document.getElementById("loader").classList.add("hidden");
          if (result.data?.status == "error") {
            commit("SET_ERRORS", [{ message: result.data["message"] }]);
          } else {
            console.log(result);
            commit("SAVE_ATT_USER", result.data);
          }
        })
        .catch(error => {
          document.getElementById("loader").classList.add("hidden");
          commit("SET_ERRORS", error);
        });
    },
    changeUserSettings(context, data) {
      console.log(data);
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "change_user_settings.php",
        headers: {
          "Content-Type": "text/plain",
          Authorization: this.state.att_user.data.token
        },
        data: JSON.stringify(data)
      };
      return new Promise((resolve, reject) => {
        axios(config)
          .then(result => {
            document.getElementById("loader").classList.add("hidden");
            if (result.data.status == "Failed") {
              reject(result.data);
            } else {
              resolve(result);
            }
          })
          .catch(error => {
            document.getElementById("loader").classList.add("hidden");
            reject(error.response.data.errors);
          });
      });
    },
    setupAttorney({ commit }, data) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "setup_attorney.php",
        headers: {
          "Content-Type": "text/plain"
        },
        data: JSON.stringify(data)
      };
      axios(config)
        .then(result => {
          document.getElementById("loader").classList.add("hidden");
          if (result.data?.data) {
            commit("SAVE_ATT_USER", result.data);
            commit("SET_ERRORS", []);
          } else {
            commit("SET_ERRORS", [{ message: "No attorney Found" }]);
          }
        })
        .catch(error => {
          document.getElementById("loader").classList.add("hidden");
          commit("SET_ERRORS", error);
        });
    },
    getTempFilesList({ commit }, data) {
      var config = {
        method: "post",
        url: Constants.API_BASE + "getTempAttorneyFiles.php",
        headers: {
          "Content-Type": "text/plain"
        },
        data: JSON.stringify(data)
      };
      axios(config)
        .then(result => {
          commit("SAVE_FILES", result.data);
        })
        .catch(error => {
          commit("SET_ERRORS", error);
        });
    },
    getFilesList({ commit }, number) {
      var config = {
        method: "post",
        url: Constants.API_BASE + "getAttorneyFiles.php",
        headers: {
          "Content-Type": "text/plain",
          Authorization: this.state.att_user.data.token
        },
        data: JSON.stringify({ attorney_number: number })
      };
      axios(config)
        .then(result => {
          commit("SAVE_FILES", result.data);
        })
        .catch(error => {
          commit("SET_ERRORS", error);
        });
    },
    deleteFile({ commit }, fileData) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "deleteAttorneyFile.php",
        headers: {
          "Content-Type": "text/plain",
          Authorization: this.state.att_user.data.token
        },
        data: JSON.stringify(fileData)
      };
      axios(config)
        .then(result => {
          document.getElementById("loader").classList.add("hidden");
          if (result.data.status == "Failed") {
            commit("SET_ERRORS", { message: result.data.message });
          } else {
            if (result.data.status == "success") {
              commit("SET_ERRORS", []);
            } else {
              commit("SET_ERRORS", [{ error: "Something went wrong" }]);
            }
            console.log(result);
          }
        })
        .catch(error => {
          document.getElementById("loader").classList.add("hidden");
          commit("SET_ERRORS", error);
        });
    },
    deleteTempFile({ commit }, fileData) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "deleteAttorneyTempFile.php",
        headers: {
          "Content-Type": "text/plain"
        },
        data: JSON.stringify(fileData)
      };
      axios(config)
        .then(result => {
          document.getElementById("loader").classList.add("hidden");
          if (result.data.status == "success") {
            commit("SET_ERRORS", []);
          } else {
            commit("SET_ERRORS", [{ error: "Something went wrong" }]);
          }
          console.log(result);
        })
        .catch(error => {
          commit("SET_ERRORS", error);
        });
    },
    uploadFile({ commit }, fileData) {
      document.getElementById("loader").classList.remove("hidden");
      axios({
        method: "post",
        url: Constants.API_BASE + "file_upload.php",
        data: fileData,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: this.state.att_user.data.token
        }
      })
        .then(result => {
          document.getElementById("loader").classList.add("hidden");
          if (result.data.status == "Failed") {
            commit("SET_ERRORS", { message: result.data.message });
          } else {
            console.log(result);
            if (result.data.status == "error") {
              commit("SET_ERRORS", [{ error: "Something went wrong" }]);
            } else {
              commit("SET_ERRORS", []);
              commit("UPLOAD_FLAG", true);
            }
          }
        })
        .catch(error => {
          commit("SET_ERRORS", error);
        });
    },
    resetUploadFlag({ commit }) {
      commit("UPLOAD_FLAG", false);
    },
    resetPasswordData({ commit }) {
      commit("SET_PASSWORD_RESET", []);
    },
    resetUpdateAttorneyFlag({ commit }) {
      commit("UPDATE_ATTORNEY_FLAG", false);
    },
    uploadTempFile({ commit }, fileData) {
      document.getElementById("loader").classList.remove("hidden");
      axios({
        method: "post",
        url: Constants.API_BASE + "file_upload_temp.php",
        data: fileData,
        headers: { "Content-Type": "multipart/form-data" }
      })
        .then(result => {
          console.log(result);
          document.getElementById("loader").classList.add("hidden");
          if (result.data.status == "error") {
            commit("SET_ERRORS", [{ error: "Something went wrong" }]);
          } else {
            commit("SET_ERRORS", []);
            commit("UPLOAD_FLAG", true);
          }
        })
        .catch(error => {
          document.getElementById("loader").classList.add("hidden");
          commit("SET_ERRORS", error);
        });
    },
    uploadCDLClaimFile(context, fileData) {
      document.getElementById("loader").classList.remove("hidden");
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: Constants.API_BASE + "cdl_claim_file_upload.php",
          data: fileData,
          headers: { "Content-Type": "multipart/form-data" }
        })
          .then(result => {
            document.getElementById("loader").classList.add("hidden");
            if (result.data.status == "Failed") {
              reject(result.data);
            } else {
              resolve(result);
            }
          })
          .catch(error => {
            document.getElementById("loader").classList.add("hidden");
            reject(error.response.data.errors);
          });
      });
    },
    uploadMatterClaimFile(context, fileData) {
      document.getElementById("loader").classList.remove("hidden");
      return new Promise((resolve, reject) => {
        axios({
          method: "post",
          url: Constants.API_BASE + "matter_claim_file_upload.php",
          data: fileData,
          headers: { "Content-Type": "multipart/form-data" }
        })
          .then(result => {
            document.getElementById("loader").classList.add("hidden");
            if (result.data.status == "Failed") {
              reject(result.data);
            } else {
              resolve(result);
            }
          })
          .catch(error => {
            document.getElementById("loader").classList.add("hidden");
            reject(error.response.data.errors);
          });
      });
    },
    addSubSequentDiscussion(context, payload) {
      payload.username=this.state.att_user.data.username;
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "create_subsequent_discussion.php",
        headers: {
          "Content-Type": "text/plain",
          Authorization: this.state.att_user.data.token
        },
        data: JSON.stringify(payload)
      };
      return new Promise((resolve, reject) => {
        axios(config)
          .then(result => {
            document.getElementById("loader").classList.add("hidden");
            if (result.data.status == "Failed") {
              reject(result.data);
            } else {
              resolve(result);
            }
          })
          .catch(error => {
            document.getElementById("loader").classList.add("hidden");
            reject(error.response.data.errors);
          });
      });
    },
    addAuthRequest(context, payload) {
      payload.username=this.state.att_user.data.username;
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "create_auth_request.php",
        headers: {
          "Content-Type": "text/plain",
          Authorization: this.state.att_user.data.token
        },
        data: JSON.stringify(payload)
      };
      return new Promise((resolve, reject) => {
        axios(config)
          .then(result => {
            document.getElementById("loader").classList.add("hidden");
            if (result.data.status == "Failed") {
              reject(result.data);
            } else {
              resolve(result);
            }
          })
          .catch(error => {
            document.getElementById("loader").classList.add("hidden");
            reject(error.response.data.errors);
          });
      });
    },
    getAuthDetails(context, payload) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "get_auth_details.php",
        headers: {
          "Content-Type": "text/plain",
          Authorization: this.state?.att_user?.data?.token
        },
        data: JSON.stringify(payload)
      };
      return new Promise((resolve, reject) => {
        axios(config)
          .then(result => {
            document.getElementById("loader").classList.add("hidden");
            if (result.data.status == "Failed") {
              reject(result.data);
            } else {
              resolve(result);
            }
          })
          .catch(error => {
            document.getElementById("loader").classList.add("hidden");
            reject(error.response.data.errors);
          });
      });
    },
    getCases({ commit }, data) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "list_of_cases.php",
        headers: {
          "Content-Type": "text/plain",
          Authorization: this.state.att_user.data.token
        },
        data: data
      };
      axios(config)
        .then(result => {
          document.getElementById("loader").classList.add("hidden");
          if (result.data.status == "Failed") {
            commit("SET_ERRORS", { message: result.data.message });
          } else {
            commit("CASES_DATA", result.data.data);
          }
        })
        .catch(error => {
          throw new Error(`API ${error}`);
        });
    },
    getReqAuthorizations({ commit }, payload) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "list_of_requests.php",
        headers: {
          "Content-Type": "text/plain",
          Authorization: this.state.att_user.data.token
        },
        data: payload
      };
      axios(config)
        .then(result => {
          document.getElementById("loader").classList.add("hidden");
          if (result.data.status == "Failed") {
            commit("SET_ERRORS", { message: result.data.message });
          } else {
            commit("AUTHORIZATION_DATA", result.data.data);
          }
        })
        .catch(error => {
          document.getElementById("loader").classList.add("hidden");
          throw new Error(`API ${error}`);
        });
    },
    getMatterCases({ commit }) {
      var config = {
        method: "get",
        url: Constants.API_BASE + "get_attorney_matters.php",
        headers: {
          "Content-Type": "text/plain",
          Authorization: this.state.att_user.data.token
        },
        data: ""
      };
      axios(config)
        .then(result => {
          if (result.data.status == "Failed") {
            commit("SET_ERRORS", { message: result.data.message });
          } else {
            commit("MATTER_CASE_DATA", result.data);
          }
        })
        .catch(error => {
          throw new Error(`API ${error}`);
        });
    },
    getCoverages({ commit }, plantype) {
      var plan;
      let i = 0;
      plantype.forEach(element => {
        if (i != 0) {
          plan = plan + ",'" + element + "'";
        } else {
          plan = "'" + element + "'";
        }
        i++;
      });
      var config = {
        method: "post",
        url: Constants.API_BASE + "getCoverages.php",
        headers: {
          "Content-Type": "text/plain"
        },
        data: { plan_class: plan }
      };
      axios(config)
        .then(result => {
          if (result.data.data.length > 0) {
            var result1 = result.data.data.reduce((unique, o) => {
              if (
                !unique.some(
                  obj => obj.desc === o.desc && obj.plan_class === o.plan_class
                ) &&
                o.desc != "General Practice" &&
                o.desc != "Out of Network Reimbursement" &&
                o.desc != "Eviction" &&
                o.desc != "Foreclosure" &&
                o.desc != "On-Scene Advice and Consultation" &&
                o.desc != "Advice and Review/Consultation"
              ) {
                unique.push(o);
              }
              return unique;
            }, []);
            console.log(result1, "result1");
            var newResult = [];
            for (let index = 0; index < result1.length; index++) {
              const element = result1[index];
              if (!newResult.some(el => el.desc === element.desc)) {
                let isRequired = false;
                if (
                  element.desc == "Personal Injury and Wrongful Death" ||
                  element.desc == "Malpractice and Negligence" ||
                  element.desc == "Labor and Employment" ||
                  element.desc == "Social Security and Disabilities" ||
                  element.desc == "Worker Compensation" ||
                  element.desc == "Government Agencies and Programs"
                ) {
                  isRequired = true;
                }
                newResult.push({
                  desc: element.desc,
                  plan_class: [element.plan_class],
                  is_required: isRequired
                });
              } else {
                let index1 = newResult.findIndex(
                  item => item.desc === element.desc
                );
                newResult[index1]["plan_class"].push(element.plan_class);
              }
            }
            result.data.att_data.forEach(element => {
              for (let index = 0; index < newResult.length; index++) {
                if (element.coverage == newResult[index]["desc"]) {
                  if (
                    newResult[index]["sub_coverage"] == undefined ||
                    newResult[index]["sub_coverage"] == null
                  ) {
                    newResult[index]["sub_coverage"] = [
                      {
                        subcoverage: element.subcoverage,
                        sub_cov_id: element.id,
                        plan_class: element.plan_class
                      }
                    ];
                  } else {
                    if (
                      !newResult[index]["sub_coverage"].some(
                        el => el.subcoverage === element.subcoverage
                      )
                    ) {
                      newResult[index]["sub_coverage"].push({
                        subcoverage: element.subcoverage,
                        sub_cov_id: element.id,
                        plan_class: element.plan_class
                      });
                    }
                  }
                }
              }
            });
            result.data.data.forEach(element => {
              for (let index = 0; index < newResult.length; index++) {
                if (element.desc == newResult[index]["desc"]) {
                  if (element.fee_schedule_code != null) {
                    if (
                      newResult[index]["fee_schedule"] == undefined ||
                      newResult[index]["fee_schedule"] == null
                    ) {
                      newResult[index]["fee_schedule"] = [
                        {
                          sub_coverage: element.sub_coverage,
                          fee_schedule_code: element.fee_schedule_code
                        }
                      ];
                    } else {
                      if (
                        !newResult[index]["fee_schedule"].some(
                          el => el.sub_coverage === element.sub_coverage
                        )
                      ) {
                        newResult[index]["fee_schedule"].push({
                          sub_coverage: element.sub_coverage,
                          fee_schedule_code: element.fee_schedule_code
                        });
                      }
                    }
                  } else {
                    newResult[index]["fee_schedule"] = [];
                  }
                }
              }
            });
            result.data.fees_data.forEach(value => {
              for (let index = 0; index < newResult.length; index++) {
                for (
                  let index1 = 0;
                  index1 < newResult[index]["fee_schedule"].length;
                  index1++
                ) {
                  if (
                    value.fee_code ==
                    newResult[index]["fee_schedule"][index1][
                      "fee_schedule_code"
                    ]
                  ) {
                    newResult[index]["fee_schedule"][index1].fee_amount =
                      value.fee_amount;
                    newResult[index]["fee_schedule"][index1].ca_fee_amount =
                      value.ca_fee_amount;
                    newResult[index]["fee_schedule"][index1].parameter =
                      value.parameter;
                  }
                }
              }
            });

            console.log(newResult, "newResult");
          }
          commit("SAVE_COVERAGES", newResult);
        })
        .catch(error => {
          throw new Error(`API ${error}`);
        });
    },
    logout({ commit }) {
      localStorage.removeItem("att_data");
      localStorage.removeItem("leadData");
      localStorage.removeItem("tempAttData");
      localStorage.removeItem("attorney_data");
      commit("SAVE_ATT_USER", []);
      commit("SAVE_LEAD", []);
      commit("SAVE_TEMP_ATT_DATA", []);
      commit("ATTORNEY_DATA", []);
    },
    getState({ commit }) {
      var config = {
        method: "get",
        url: Constants.API_BASE + "getState.php",
        headers: {
          "Content-Type": "text/plain"
        },
        data: ""
      };
      axios(config)
        .then(result => {
          commit("SAVE_STATE", result.data.data);
        })
        .catch(error => {
          throw new Error(`API ${error}`);
        });
    },
    getCounty({ commit }, stateId) {
      var config = {
        method: "post",
        url: Constants.API_BASE + "getCounty.php",
        headers: {
          "Content-Type": "text/plain"
        },
        data: { State: stateId }
      };

      axios(config)
        .then(result => {
          commit("SAVE_COUNTY", result.data);
        })
        .catch(error => {
          throw new Error(`API ${error}`);
        });
    },
    getAddressCounty({ commit }, data) {
      var config = {
        method: "post",
        url: Constants.API_BASE + "getAddressCounty.php",
        headers: {
          "Content-Type": "text/plain"
        },
        data: data
      };
      axios(config)
        .then(result => {
          commit("SAVE_ADDRESS_COUNTY", result.data.data);
        })
        .catch(error => {
          throw new Error(`API ${error}`);
        });
    },
    // Added By Vishal
    /* This is for claims */
    getCaseList({ commit }, data) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.CLAIM_BASE + "case_list.php",
        headers: {
          "Content-Type": "text/plain",
          Authorization: this.state.att_user.data.token
        },
        data: data
      };
      return new Promise((resolve, reject) => {
        axios(config)
          .then(result => {
            document.getElementById("loader").classList.add("hidden");
            if (result.data == null) {
              result.data = { data: { case_list: [] } };
            }
            if(result.data.case_list==[]){
              result.data = { data: { case_list: [] } };
            }
            if (result.data.status == "Failed") {
              reject(result.data);
            } else {
              commit("SAVE_CASE_LIST", result.data.data.case_list);
              resolve(result);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getCasedetails({ commit }, data) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.CLAIM_BASE + "cdl_case_details.php",
        headers: {
          "Content-Type": "text/plain",
          Authorization: this.state.att_user.data.token
        },
        data: data
      };
      axios(config)
        .then(result => {
          document.getElementById("loader").classList.add("hidden");
          if (result.data == null) {
            result.data = { data: { cdl_case_list: [] } };
          }
          commit("SAVE_CDL_CASE_LIST", result.data.data.cdl_case_list);
        })
        .catch(error => {
          throw new Error(`API ${error}`);
        });
    },
    getMatterCasedetails(context, data) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.CLAIM_BASE + "matter_case_details.php",
        headers: {
          "Content-Type": "text/plain",
          Authorization: this.state.att_user.data.token
        },
        data: JSON.stringify(data)
      };
      return new Promise((resolve, reject) => {
        axios(config)
          .then(result => {
            document.getElementById("loader").classList.add("hidden");
            if (result.data.status == "Failed") {
              reject(result.data);
            } else {
              resolve(result);
            }
          })
          .catch(error => {
            document.getElementById("loader").classList.add("hidden");
            reject(error.response.data.errors);
          });
      });
    },
    getCDLCasedetails(context, data) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.CLAIM_BASE + "cdl_case_details.php",
        headers: {
          "Content-Type": "text/plain",
          Authorization: this.state.att_user.data.token
        },
        data: JSON.stringify(data)
      };
      return new Promise((resolve, reject) => {
        axios(config)
          .then(result => {
            document.getElementById("loader").classList.add("hidden");
            if (result.data.status == "Failed") {
              reject(result.data);
            } else {
              resolve(result);
            }
          })
          .catch(error => {
            document.getElementById("loader").classList.add("hidden");
            reject(error.response.data.errors);
          });
      });
    },
    getDisposition(context, data) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "get",
        url: Constants.CLAIM_BASE + "get_dispositions.php",
        headers: {
          "Content-Type": "text/plain",
          Authorization: this.state.att_user.data.token
        },
        data: JSON.stringify(data)
      };
      return new Promise((resolve, reject) => {
        axios(config)
          .then(result => {
            document.getElementById("loader").classList.add("hidden");
            if (result.data.status == "Failed") {
              reject(result.data);
            } else {
              resolve(result);
            }
          })
          .catch(error => {
            document.getElementById("loader").classList.add("hidden");
            reject(error.response.data.errors);
          });
      });
    },
    CreateClaim(context, data) {
      data.username=this.state.att_user.data.username;
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.CLAIM_BASE + "create_claim.php",
        headers: {
          "Content-Type": "text/plain",
          Authorization: this.state.att_user.data.token
        },
        data: JSON.stringify(data)
      };
      return new Promise((resolve, reject) => {
        axios(config)
          .then(result => {
            document.getElementById("loader").classList.add("hidden");
            if (result.data.status == "Failed") {
              reject(result.data);
            } else {
              resolve(result);
            }
          })
          .catch(error => {
            document.getElementById("loader").classList.add("hidden");
            reject(error.response.data.errors);
          });
      });
    },
    dataDecrypt(context, payload) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "data_decrypt.php",
        headers: {
          "Content-Type": "text/plain"
        },
        data: {data:JSON.stringify(payload)}
      };
      return new Promise((resolve, reject) => {
        axios(config)
          .then(result => {
            document.getElementById("loader").classList.add("hidden");
            if (result.status == "error") {
              reject(result.data);
            } else {
              resolve(result);
            }
          })
          .catch(error => {
            document.getElementById("loader").classList.add("hidden");
            reject(error.response.data.errors);
          });
      });
    },
    getToken(context, payload) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.AGEN_API + "agent_login.php",
        headers: {
          "Content-Type": "text/plain"
        },
        data: {data:JSON.stringify(payload)}
      };
      return new Promise((resolve, reject) => {
        axios(config)
          .then(result => {
            document.getElementById("loader").classList.add("hidden");
            if (result.status == "Not found") {
              reject(result.data);
            } else {
              resolve(result);
            }
          })
          .catch(error => {
            document.getElementById("loader").classList.add("hidden");
            reject(error.response.data.errors);
          });
      });
    },
    getCaseDetails(context, payload) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.AGEN_API + "get_case_details.php",
        headers: {
          "Content-Type": "text/plain",
          Authorization: payload.token
        },
        data: JSON.stringify(payload)
      };
      return new Promise((resolve, reject) => {
        axios(config)
          .then(result => {
            console.log(result)
            document.getElementById("loader").classList.add("hidden");
            if (result.data.status == "Failed") {
              reject(result.data);
            } else {
              resolve(result);
            }
          })
          .catch(error => {
            document.getElementById("loader").classList.add("hidden");
            reject(error.response.data.errors);
          });
      });
    },
    CaseConfirmation(context, payload) {
      document.getElementById("loader").classList.remove("hidden");
      var config = {
        method: "post",
        url: Constants.API_BASE + "create_todo_note.php",
        headers: {
          "Content-Type": "text/plain"
        },
        data: JSON.stringify(payload)
      };
      return new Promise((resolve, reject) => {
        axios(config)
          .then(result => {
            console.log(result)
            document.getElementById("loader").classList.add("hidden");
            if (result.data.status == "error") {
              reject(result.data);
            } else {
              resolve(result);
            }
          })
          .catch(error => {
            document.getElementById("loader").classList.add("hidden");
            reject(error.response.data.errors);
          });
      });
    }
  },
  modules: {}
});
export default store;
